// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"ed71ca30","222":"ed71ca30","265":"2fc7209d","315":"936998c4","767":"ed71ca30"}[chunkId] + ".chunk.css";
};